<template>
  <div :class="{'artist-card-profile': isProfile}" class="artist-card relative flex pointer dim pa3 cover bg-center resize">
    <div class="flex-column w-100">
      <router-link class="artist-info" :to="{ name:'artist-info', params:{ id: artist.id }}">
        <div class="body relative hide-child">
          <span
            v-if="hasTracks"
            class="white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer">
            <div class="grow ba bw2 br-100 h3 w3 flex items-center justify-center" @click.prevent="playArtistTracks()">
              <font-awesome-icon icon="play" size="2x"/>
            </div>
          </span>
          <img v-if="artist.recommended" :class="{'isArtistList': isArtistList, 'isProfile': isProfile}" class="artist-picture db beathey-loud" src="https://beathey.com/uploads/LOUD/BTH+LOUD%C2%AE-02.svg" :style="{'display': 'block' , 'margin-left': 'auto' , 'margin-right': 'auto'}"/>
          <img :class="{'isArtistList': isArtistList, 'isProfile': isProfile}" class="artist-picture db" :src="listPicture" :alt="`${artist.name} Picture`" :style="{'display': 'block' , 'margin-left': 'auto' , 'margin-right': 'auto'}">
        </div>
        <div class="flex items-center bg-primary mw-90 justify-around">
          <p class="z-1 white-90 word-wrap flex f5 artist-name ma3">{{ artist.name }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import {mapActions} from 'vuex'
  import consts from '@/consts'

  export default {
    name: 'artist-card',
    props: {
      artist: {
        default: null
      },
      isArtistList: {
        default: false
      },
      isProfile: {
        default: false
      }
    },
    components: {FontAwesomeIcon},
    computed: {
      hasTracks () {
        return this.artist.tracks && this.artist.tracks.length > 0
      },
      listPicture () {
        if (this.artist.picture) {
          if (this.isProfile) {
            return consts.MEDIA_BASE_URL + '/uploads/users/' + this.artist.picture
          } else {
            return consts.MEDIA_BASE_URL + this.artist.picture
          }
        } else {
          return '/static/assets/Img_Avatar_generico_Beathey.jpg'
        }
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaylist',
        'playFirstTrack'
      ]),
      playArtistTracks () {
        this.setPlaylist(this.artist.tracks)
        this.playFirstTrack()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  a.artist-info:link, a.artist-info:visited {
    color: #FFFFFF;
    text-decoration: none;
  }

  .artist-card {
    width: 15rem;
    flex-shrink: 0;
    flex-grow: 0;
    transition: all .6s;
  }

  .beathey-loud {
    height: 150px;
    width: 150px;
    z-index: 1;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  .artist-card-profile {
    width: 12rem !important;
  }

  .artist-name {
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 18px;
    font-weight: bolder;
    font-size: 0.775rem;
  }

  .artist-picture {
    line-height: 0;
    height: 150px;
    object-fit: cover;
    width: 150px;
    border-radius: 100%;
  }

  .word-wrap {
    word-break: break-all;
  }

  // .resize:hover {
  //   width: 15rem !important;
  //   .artist-picture {
  //     height: 190px;
  //     width: 220px;
  //   }
  //   .beathey-loud {
  //     height: 190px;
  //     width: 15rem !important;

  //   }
  // }

  .isArtistList {
    height: 150px;
  }
  .isProfile {
    height: 155px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/artists/ArtistCard.vue